import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-black-union-line.scss";

export class WebsiteBlackUnionLineComponent extends Component {
    constructor(color?: string) {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackUnionLine} ${color ? s[color] : ``}">
                <div class="${s.line}"></div>
                <div class="${s.blur}"></div>
            </div>
        `;
    }
}